import { gql } from 'urql';

export default gql`
  mutation SetAccountNicknameR2(
    $idempotencyId: String!
    $accountId: ID!
    $nickname: String!
  ) {
    setAccountNicknameR2(
      idempotencyId: $idempotencyId
      input: { accountId: $accountId, nickname: $nickname }
    ) {
      id
      nickname
    }
  }
`;
